<template lang="pug">
  .container
    .card
      cadastro-sicarf(titleCadastro="Solicitar cancelamento de cláusula resolutiva", routeName="central/liberacao-clausula", :cadastroEmpty="empty", :tabs="tabs")
</template>

<script>
import CadastroSicarf from '@/screens/central/components/CadastroSicarf'
import empty from '../empty/emptyLiberacaoClausulaResolutiva'

export default {

  components: {
    CadastroSicarf
  },

  data () {
    return {
      // O atributo @name deve ser o mesmo da rota definida no router
      tabs: this.$route.path.includes('central') ? [
        {
          label: 'Cadastrante',
          name: 'liberacao-clausula/cadastrante',
          codigo: 'CADASTRANTE'
        },
        {
          label: 'Interessado',
          name: 'liberacao-clausula/interessado',
          codigo: 'INTERESSADO'
        },
        {
          label: 'Imóvel',
          name: 'liberacao-clausula/imovel',
          codigo: 'IMOVEL'
        },
        {
          label: 'Resumo',
          name: 'liberacao-clausula/resumo',
          isResumo: true
        }
      ] : [
        {
          label: 'Cadastrante',
          name: this.$route.path.split('/')[1] + '/liberacao-clausula/cadastrante',
          codigo: 'CADASTRANTE'
        },
        {
          label: 'Interessado',
          name: this.$route.path.split('/')[1] + '/liberacao-clausula/interessado',
          codigo: 'INTERESSADO'
        },
        {
          label: 'Imóvel',
          name: this.$route.path.split('/')[1] + '/liberacao-clausula/imovel',
          codigo: 'IMOVEL'
        },
        {
          label: 'Resumo',
          name: this.$route.path.split('/')[1] + '/liberacao-clausula/resumo',
          isResumo: true
        }
      ],
      empty: empty
    }
  }

}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  .card {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/maranhao/liberacao/Cadastro.vue